module.exports = __webpack_public_path__ + "media/images/icons/outlined/forward-d08b39ef3ccf86a5d9024a9755ffdfe8.svg";